<template>
    <div id="main">
        <div class="page">
            <loader v-if="isLoading" />
            <alert-container :messages="msgs" />
            <div class="listing-header mb-2">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('localizacao-colaborador') }}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="onFecharModal">
                        {{ $t('voltar') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <div class="location">
                    <GoogleMaps
                        ref="gmap"
                        :center="local"
                        :geocoded="true"
                        :startmarker="true"
                        :zoom="zoom"
                        :options="mapOptions"
                        :clickMoveMarker="false"
                        :clickable="true"
                    >
                        <template v-slot:detail>
                            <h1 class="title-location">{{ $t('dados-localizacao') }}</h1>
                            <p>{{ $t('datahora') }}: {{ local.datahora }}</p>
                            <p>{{ $t('latitude') }}: {{ local.lat }}</p>
                            <p>{{ $t('longitude') }}: {{ local.lng }}</p>
                            <p>{{ $t('velocidade') }}: {{ local.velocidade }}</p>
                            <p>{{ $t('precisao') }}: {{ local.precisao }}</p>
                        </template>
                    </GoogleMaps>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// COMPONENTS
import GoogleMaps from '@/components/shared/maps/MapasGoogleMaps';

export default {
    components: {
        GoogleMaps,
    },
    props: {
        local: {
            default: () => {
                return {
                    lat: 0,
                    lng: 0,
                    datahora: null,
                    velocidade: null,
                    precisao: null,
                };
            },
        },
    },
    data() {
        return {
            zoom: 13,
            isLoading: false,
            isEmpty: false,
            msgs: [],
            mapOptions: { gestureHandling: 'cooperative' },
        };
    },
    created() {},
    methods: {
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    margin-bottom: 40px;
    min-height: 400px;
    padding: 17px 15px;
    border-radius: 5px;

    .location {
        margin-top: 5px;
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        position: relative;
        min-height: 350px;
        height: auto;
        display: block;
        clear: both;
        border: solid 2px #f9f9f9;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        .title-location {
            color: $primary-color-click;
            font-weight: 600;
            text-transform: uppercase;
        }
    }
}
</style>
